import {
	ChangeDetectionStrategy,
	ChangeDetectorRef,
	Component,
	EventEmitter,
	Input,
	OnDestroy,
	OnInit,
	Output
} from '@angular/core';
import { EventEmitterService } from 'app/api/event.service';
import { IServiceRequestFiles } from 'app/charts/domain-model';
import { FileItem, FileUploader } from 'ng2-file-upload';
import { IMachine } from '../../api/domain-model';
import { NotificationService } from '../notifications/notification.service';
import { TranslateService } from '../translate/translate.service';
import {StorageService} from "../storage-service";
@Component({
    selector: 'file-upload-multiple',
    templateUrl: './file-upload-multiple.component.html',
    styleUrls: ['./file-upload-multiple.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class FileUploadMultipleComponent implements OnInit, OnDestroy {
	changeDetectionSubscribe;

	title = 'ng8fileupload';
	public maxFileFize = 15 * 1024 * 1024;
	public limitFile = 30;
	public acceptedFileTypes = [
		'image/jpg',
		'image/jpeg',
		'image/png',
		'application/msword',
		'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
		'application/pdf',
		'application/vnd.ms-powerpoint',
		'application/vnd.openxmlformats-officedocument.presentationml.presentation',
		'text/plain',
		'application/vnd.ms-excel',
		'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
		'text/csv',
		'application/zip',
		'application/octet-stream',
		'application/x-zip-compressed',
		'multipart/x-zip',
		'application/x-7z-compressed',
		'text/xml',
		'application/xml'
	];
	public uploader: FileUploader = new FileUploader({
		// url ist ab ng2-file-upload 3.0.0 ein Pflichtfeld. Die echte Adresse
		// setzt setOptions() unmittelbar vor uploadAll(); hier nur ein Platzhalter.
		url: '',
		itemAlias: 'file',
		queueLimit: this.limitFile,
		maxFileSize: this.maxFileFize,
		allowedMimeType: this.acceptedFileTypes
	});
	public fileUploadingInProgress: boolean;

	@Output()
	public newFileAdded = new EventEmitter<boolean>();

	@Output()
	public fileUploaded = new EventEmitter<string>();

	@Output()
	public filesUploadCompleted = new EventEmitter<boolean>();

	@Input() fileUploadUri: string;
	@Input() onSuccessMessageKeys: Array<string>;
	@Input() onErrorMessageKeys: Array<string>;
	@Input() uploadButtonText: string;
	@Input() multipleFiles: boolean = true;

	public filesList: IServiceRequestFiles[] = [];

	// tslint:disable-next-line:no-input-rename
	@Input('machine') machine: IMachine;

	getMachine(): IMachine {
		return this.machine;
	}

	get lang() {
		return window.location.pathname.split('/')[2];
	}

	constructor(
		private notificationService: NotificationService,
		private translateService: TranslateService,
		private storageService: StorageService,
		private cd: ChangeDetectorRef,
		private eventEmitterService: EventEmitterService
	) {}

	ngOnInit() {
		if (!this.multipleFiles) {
			this.limitFile = 1;
		}

		this.uploader.onWhenAddingFileFailed = (file, filter) => {
			let validation = '';

			if (filter.name === 'fileSize') {
				validation = this.translateService.instant(
					'N88ServiceRequestFileSizeError'
				);
			} else if (filter.name === 'mimeType') {
				validation = this.translateService.instant(
					'N89ServiceRequestFileTypeError'
				);
			} else if (filter.name === 'queueLimit') {
				validation = this.translateService.instant(
					'N94ServiceRequestFileLimitError'
				);
			}

			this.filesList.push({
				name: file.name,
				size: file.size,
				validation
			});
		};

		this.uploader.onAfterAddingFile = (file) => {
			this.newFileAdded.emit(true);

			this.filesList.push({
				name: file.file.name,
				size: file.file.size
			});

			file.withCredentials = false;
		};

		this.uploader.onSuccessItem = (item: FileItem, response: string) => {
			this.filesList.length = 0;
			// this.uploader.clearQueue();
			this.fileUploadingInProgress = false;
			let message = '';
			this.onSuccessMessageKeys.forEach(
				(messageKey) =>
					(message = message + ' ' + this.translateService.instant(messageKey))
			);
			this.notificationService.showOK(message);
			this.fileUploaded.emit(response);
			this.cd.markForCheck();
		};

		this.uploader.onErrorItem = (item: FileItem, response: string) => {
			this.filesList.length = 0;
			this.uploader.clearQueue();
			this.fileUploadingInProgress = false;
			let message = '';
			this.onErrorMessageKeys.forEach(
				(messageKey) =>
					(message = message + ' ' + this.translateService.instant(messageKey))
			);
			this.notificationService.showError(message);
			this.cd.markForCheck();
		};

		this.uploader.onCompleteAll = () => {
			this.filesUploadCompleted.emit(true);
		};

		this.changeDetectionSubscribe =
			this.eventEmitterService.langtrigger.subscribe((lang) => {
				this.cd.markForCheck();
			});
	}

	uploadFile(): void {
		this.fileUploadingInProgress = true;
		this.uploader.setOptions({
			url: this.fileUploadUri,
			authTokenHeader: 'Authorization',
			authToken: `Bearer ${
				JSON.parse(this.storageService.getToken()).access_token
			}`
		});
		this.uploader.uploadAll();
	}

	formatBytes(bytes, decimals = 2) {
		if (bytes === 0) return '0 Bytes';

		const k = 1024;
		const dm = decimals < 0 ? 0 : decimals;
		const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

		const i = Math.floor(Math.log(bytes) / Math.log(k));

		return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
	}

	ngOnDestroy(): void {
		this.changeDetectionSubscribe.unsubscribe();
	}
}
